class OnlineItemResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource, { contentApi, gatewayApi }) {
        return headers => {
            return $resource(contentApi.url + "/v1/items/:id", {id: "@id"}, {
                get: {
                    method: "GET"
                },
                update: {
                    method: "PUT",
                    isArray: true
                },
                publish: {
                    method: "POST",
                    url: contentApi.url + "/v1/items/:id/publish",
                    headers: headers || {}
                },
                getBids: {
                    method: "GET",
                    url: `${gatewayApi.url}/v1/items/:id/online/bids`,
                    isArray: true
                }
            });
        };
    }
}

angular
    .module("thor.core.online-item.resource", [])
    .factory("onlineItemResource", OnlineItemResource);
